import * as R from 'ramda'
import {
  Exceptions,
  GET_CHANNEL,
  GetChannelAPI,
  JOIN_CHANNEL,
  JoinChannelAPI,
  OPEN_CHANNEL_PROFILE,
  OPEN_CHANNEL_ROOM,
  OpenChannelProfileAPI,
  OpenChannelRoomAPI,
  GetAdminChannelsAPI,
  GET_ADMIN_CHANNELS,
} from '@weblite-wapps/protocol'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'
import { getHall } from '$logic/hall'
import { getRoom, isClientsRoom } from '$logic/room'
import { openHallProfile } from '$logic/router'
import { getImageUrl } from '$func/imageUrl'
import { joinHall } from '$logic/subscription'
import { openRoom } from '$logic/opened-room'
import { getAdministeredChannels } from '$logic/administered-channels'

wappSubscription.subscribe<GetChannelAPI>(GET_CHANNEL, async payload => {
  const hall = await getHall(payload.roomId)
  if (!hall) return { errorCode: Exceptions.NOT_FOUND }

  return {
    ...R.pick(
      [
        'roomId',
        'identifier',
        'name',
        'description',
        'membersCount',
        'public',
        'verified',
      ],
      hall,
    ),
    deleted: !!hall.deletedAt,
    image: getImageUrl(hall.image),
  }
})

wappSubscription.subscribe<OpenChannelProfileAPI>(
  OPEN_CHANNEL_PROFILE,
  async payload => {
    const room = await getRoom(payload.roomId)
    if (!room) return { errorCode: Exceptions.NOT_FOUND }

    if (room.type !== 'CHANNEL') return { errorCode: Exceptions.NOT_ALLOWED }

    await openHallProfile(payload.roomId)
    return { status: 'ok' }
  },
)

wappSubscription.subscribe<OpenChannelRoomAPI>(
  OPEN_CHANNEL_ROOM,
  async payload => {
    const room = await getRoom(payload.roomId)
    if (!room) return { errorCode: Exceptions.NOT_FOUND }

    if (room.type !== 'CHANNEL') return { errorCode: Exceptions.NOT_ALLOWED }

    await openRoom(payload.roomId)
    return { status: 'ok' }
  },
)

wappSubscription.subscribe<JoinChannelAPI>(JOIN_CHANNEL, async ({ roomId }) => {
  const room = await getRoom(roomId)
  if (!room) return { errorCode: Exceptions.NOT_FOUND }

  if (room.type !== 'CHANNEL') return { errorCode: Exceptions.NOT_ALLOWED }

  if (!isClientsRoom(roomId)) {
    const hall = await getHall(roomId)
    analite('CHAT_JOIN', { source: 'VITRINE', name: hall?.identifier })
    const success = await joinHall(roomId)
    if (success) return { status: 'ok' }
    return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }
  }
  return { status: 'ok' }
})

wappSubscription.subscribe<GetAdminChannelsAPI>(
  GET_ADMIN_CHANNELS,
  async () => {
    return await getAdministeredChannels()
  },
)
